<div class="content-wrapper">

  <section class="content-header">
    <h1>
      Tutoriais
      <small>Apostilas de usabilidade do sistema</small>
    </h1>
    <ol class="breadcrumb">
      <li><a routerLink="/home"><i class="fa fa-home"></i> Home</a></li>
      <li class="active">Tutoriais</li>
    </ol>
  </section>

  <section class="content">
    <div class="row">
      <div class="col-sm-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <i class="fa fa-graduation-cap" style="margin-right:8px; color:#0073b7;"></i>
              Apostilas e tutoriais
            </h3>
          </div>
          <div class="box-body" style="padding:24px;">

            <!-- Listagem de tópicos -->
            <div *ngIf="!mostraConteudo">

              <p style="color:#6b7280; margin-bottom:20px;">
                Selecione um tópico para visualizar os tutoriais disponíveis.
              </p>

              <div style="display:grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap:16px;">
                <div *ngFor="let item of topicos"
                  (click)="mostrarConteudoDoTopico(item)"
                  style="background:#fff; border:1px solid #e5e7eb; border-radius:12px; padding:20px; cursor:pointer; transition:box-shadow 0.2s, border-color 0.2s;"
                  onmouseover="this.style.boxShadow='0 4px 12px rgba(59,130,246,0.12)'; this.style.borderColor='#93c5fd';"
                  onmouseout="this.style.boxShadow='none'; this.style.borderColor='#e5e7eb';">
                  <div style="display:flex; align-items:center; gap:12px; margin-bottom:10px;">
                    <div style="width:42px; height:42px; background:#eff6ff; border-radius:10px; display:flex; align-items:center; justify-content:flex-start; padding-left:11px; flex-shrink:0;">
                      <i class="far fa-file-alt" style="color:#0073b7; font-size:18px;"></i>
                    </div>
                    <strong style="color:#111827; font-size:15px; line-height:1.3;">{{ item.tutTopico.titulo }}</strong>
                  </div>
                  <p style="color:#6b7280; margin:0; font-size:13px; line-height:1.6;">{{ item.tutTopico.descricao }}</p>
                  <div style="display:flex; justify-content:flex-end; margin-top:14px;">
                    <span style="font-size:12px; color:#0073b7; font-weight:600;">
                      Ver tutoriais <i class="fa fa-chevron-right" style="font-size:10px;"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div *ngIf="topicos.length === 0"
                style="text-align:center; padding:48px 24px; color:#9ca3af;">
                <i class="fa fa-inbox" style="font-size:40px; margin-bottom:12px; display:block;"></i>
                <p style="margin:0; font-size:15px;">Nenhum tutorial disponível para o seu perfil.</p>
              </div>

            </div>

            <!-- Conteúdo do tópico selecionado -->
            <div *ngIf="mostraConteudo">

              <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:20px;">
                <div style="display:flex; align-items:center; gap:10px;">
                  <button type="button" (click)="voltarTopicos()"
                    style="background:none; border:1px solid #d1d5db; border-radius:8px; padding:6px 12px; cursor:pointer; display:flex; align-items:center; gap:6px; color:#374151; font-size:13px;">
                    <i class="fa fa-arrow-left" style="font-size:11px;"></i> Voltar
                  </button>
                  <div style="display:flex; align-items:center; gap:8px;">
                    <div style="width:36px; height:36px; background:#eff6ff; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0;">
                      <i class="far fa-file-alt" style="color:#0073b7; font-size:16px;"></i>
                    </div>
                    <div>
                      <div style="font-weight:700; color:#111827; font-size:16px;">{{ topicoSelecionado.titulo }}</div>
                      <div style="font-size:12px; color:#6b7280;">{{ conteudo.length }} tutorial(is)</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="display:flex; flex-direction:column; gap:10px;">
                <div *ngFor="let item of conteudo; let i = index"
                  style="display:flex; align-items:center; justify-content:space-between; padding:14px 16px; background:#f8fafc; border-radius:10px; border-left:4px solid #0073b7; gap:12px;">
                  <div style="display:flex; align-items:center; gap:12px; flex:1; min-width:0;">
                    <span style="background:#dbeafe; color:#0073b7; font-weight:700; font-size:12px; min-width:28px; height:28px; border-radius:50%; display:flex; align-items:center; justify-content:center; flex-shrink:0;">
                      {{ i + 1 }}
                    </span>
                    <span style="color:#374151; font-size:14px; line-height:1.4;">{{ item.descricao }}</span>
                  </div>
                  <button (click)="visualizarVideo(item)"
                    style="background:#16a34a; border:none; border-radius:8px; padding:8px 14px; cursor:pointer; display:flex; align-items:center; gap:6px; color:#fff; font-size:13px; font-weight:600; white-space:nowrap; flex-shrink:0;">
                    <i class="fa fa-play" style="font-size:11px;"></i> Assistir
                  </button>
                </div>
              </div>

              <div *ngIf="conteudo.length === 0"
                style="text-align:center; padding:40px 24px; color:#9ca3af;">
                <i class="fa fa-video-camera" style="font-size:36px; margin-bottom:12px; display:block;"></i>
                <p style="margin:0; font-size:14px;">Nenhum conteúdo disponível neste tópico.</p>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </section>

</div>


<p-dialog
  header="Visualizar tutorial"
  [(visible)]="mostraVideo"
  [style]="{width: '860px'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeModalVideo()">

  <div style="padding:4px 0;">
    <video
      controls
      controlsList="nodownload"
      loop
      width="100%"
      style="border-radius:8px; background:#000;"
      [src]="caminhoVideo"
      type="video/mp4">
    </video>
  </div>

</p-dialog>
